import styled from 'styled-components';

export const Container = styled.div``;

export const ContractsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 60%;
  margin-top: 0.875rem;

  & > button {
    margin-top: 0.5rem;
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 24rem;
    flex-direction: row;

    & > button {
      width: unset;
      margin: 0;
    }
  }
`;

export const FinancialsHeader = styled.header`
  display: flex;
  flex-direction: column;

  background-color: ${({ theme }) => theme.colors.white};
  margin-bottom: 0.5rem;
  padding: 1.5rem;
  border-bottom: 0.5rem solid ${({ theme }) => theme.colors.gray8};

  & > .title {
    font-size: 1.625rem;
    font-weight: 700;
    margin-bottom: 1.25rem;
  }

  & > .subtitle {
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark2};
  }
`;

export const CustomersContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 60%;
  margin-top: 0.875rem;

  & > button {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 24rem;
    flex-direction: row;

    & > button {
      width: unset;
    }
  }

  & > div.input-status {
    min-width: 10.75rem;
    margin-right: 1.5rem;
  }

  & > div.input-container {
    width: 100%;

    &:not(:first-child) {
      margin-top: 1rem;

      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        margin-top: unset;
      }
    }

    & > h4 {
      color: ${({ theme }) => theme.colors.grayDark2};
      font-weight: bold;
      font-size: 0.875rem;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      min-width: 16.688rem;
      margin-right: 1.5rem;
      margin-bottom: unset;
    }
  }

  & > div.actions {
    display: flex;
    margin-top: 1.25rem;
    width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      margin-top: unset;

      & > button {
        min-width: 10.75rem;
      }
    }

    & > button {
      &.clear {
        color: ${({ theme }) => theme.colors.grayDark};

        &:hover {
          color: ${({ theme }) => theme.colors.blue};
        }
      }
    }
  }
`;
